import React, { useState } from 'react';
import styles from './style.module.css';
import lixeiraIcon from './lixeira.svg';

const DropdownMenu = ({ queueFunction, deleteFunction }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <div className={styles.dropdown}>
       <button onClick={toggleDropdown} className={styles.dropdownButton}>
        Opções <span className={isOpen ? styles.arrowUp : styles.arrowDown}>▼</span>
      </button>
      {isOpen && (
        <div className={styles.dropdownContent}>
          <a onClick={() => queueFunction(true)}>Criar Fila</a>
          <a onClick={() => deleteFunction(true)}><img src={lixeiraIcon} alt="Deletar" style={{ width: '15px', height: '15px', marginRight: 20, verticalAlign: 'middle', marginLeft: -20 }} />Deletar base</a>
          {/* <a href="#editar">Editar</a>
          <a href="#emitir-boleto">Emitir boleto</a>
          <a href="#confissao-divida">Confissão de dívida</a>
          <a href="#mandar-mensagem">Mandar mensagem</a> */}
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
